module.exports = __webpack_public_path__ + "img/Vector.34c8c63c.svg";